export default "__VITE_ASSET__jmDrSKBY__"